import React from 'react';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import {FormatListNumbered } from '@material-ui/icons';
import ApiServices from 'services/ApiServices';
import {showMessagePersonalizedPosition,} from 'services/SweetAlert'
import Title from 'components/TitleWithIcon';
import ComponenteDialogEliminarRegistro from 'components/CustomDialog';
import DialogLoadingMessage from 'components/LoadingMessage/index'
import FormularioEditarEliminarRegistro from './FormularioEditarEliminarRegistro';

function ComponenteEliminarRegistro(props) {
    const classes = useStyles(),        
        [loading, setLoading] = React.useState(false);
        const EliminarRegistroDeFallecido= async ()=>{
            setLoading(true)
            try{
                const response =  await ApiServices.captacionFallecidos.eliminarFallecido({iddetalle: props.idRegistro})
                if(response.error!==null){
                    showMessagePersonalizedPosition('error','Oopss!', response.error.message,'center')
                }else{
                    showMessagePersonalizedPosition('success','¡BIEN!', response.data,'center')
                    props.actualizarTabla()
                    props.cerrarComponenteEliminarRegistro()
                }   
            }catch(exception){
                if (exception.status===404) {
                    showMessagePersonalizedPosition('error','Oopss!', 'Falla del Sistema. póngase en contacto con el Administrador sí este mensaje persiste.','center')
                }
                else {
                    showMessagePersonalizedPosition('error','Oopss!', 'Intente de nuevo. póngase en contacto con el Administrador sí este mensaje persiste.','center')
                }
            }                 
            setLoading(false)
        };
    return (
        <div id="scroller" className={classes.root}>
            {/* <DialogLoadingMessage open={loading} title={'Eliminando Registro de Fallecido ...'}/> */}
            <ComponenteDialogEliminarRegistro 
                title={'Eliminar Registro de Fallecido'}
                open={props.open}
                fullScreen={true}
                closeModal={props.cerrarComponenteEliminarRegistro}
                actualizarTabla={props.actualizarTabla}
                idRegistroRenap={props.idRegistro}
                iconToolbar={<FormatListNumbered />}
                titleToolbar={'Registro No. '+props.idRegistro}                                    
            >            
                <Title title="Lectura y/o eliminación de registro de fallecido" icon={"/assets/updateAndDelete.png"}/>
                <br/>

                <FormularioEditarEliminarRegistro 
                    // disabled={props.disabled}
                    IsFormDelete={true}
                    saveDatatoFormDeleteAndEdit={props.saveDatatoFormDeleteAndEdit} 
                    open={props.open}
                    actualizarTabla={props.actualizarTabla}
                    cerrar={props.cerrarComponenteEliminarRegistro}
                    idRegistroRenap={props.idRegistro}
                />
            </ComponenteDialogEliminarRegistro>
        </div>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(ComponenteEliminarRegistro);